import { render, staticRenderFns } from "./CoTag.vue?vue&type=template&id=c7d57f84&scoped=true&"
import script from "./CoTag.vue?vue&type=script&lang=js&"
export * from "./CoTag.vue?vue&type=script&lang=js&"
import style0 from "./CoTag.vue?vue&type=style&index=0&id=c7d57f84&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d57f84",
  null
  
)

export default component.exports